export default function PhilosophySection() {
  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12 max-w-4xl">
        <div className="text-center mb-12">
          <span className="text-cyan-500 text-sm font-semibold tracking-wider uppercase">Philosophy</span>
        </div>
        
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
          私たちの理念
        </h2>

        <div className="bg-gray-50 border-l-8 border-cyan-500 rounded-3xl p-12 mb-12">
          <p className="text-3xl font-bold text-gray-900 leading-relaxed mb-4">
            「作業ではなく、一人ひとりに向き合う介護」
          </p>
        </div>

        <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
          <p>
            私たちまごころヘルパーは、介護を単なる「作業」として捉えるのではなく、ご利用者様一人ひとりの人生、価値観、想いに真摯に向き合うことを最も大切にしています。
          </p>
          <p>
            高齢になっても、介護が必要になっても、その方らしい生活を続けていただきたい。そのために私たちは、マニュアル通りのケアではなく、その方の個性や生活スタイルを尊重し、心を込めたサポートを提供します。
          </p>
          <p>
            「まごころ」という言葉には、真心、誠意、思いやりといった意味が込められています。私たちは、この「まごころ」を持って、ご利用者様とそのご家族に寄り添い、安心と笑顔をお届けすることを使命としています。
          </p>
          <p>
            また、スタッフ一人ひとりが成長し、やりがいを感じながら働ける環境づくりにも力を入れています。温かいチームワークと充実した教育体制で、未経験の方でも安心してキャリアをスタートできる職場を目指しています。
          </p>
        </div>
      </div>
    </section>
  );
}
